/* eslint-env browser */
import UriHelper from './utils';

require('choices.js');

((window, $) => {
  const doc = window.document;

  class SearchFilter {
    constructor(name, options = {}) {
      this.name = name;
      this.items = [];
      this.selectedFilters = [];
      this.applyBtn = null;
      this.paramName = options.paramName;
    }

    init() {
      this.filterOptionsContainer = doc.getElementById(`${this.name}-filter-options`);
      if (!this.filterOptionsContainer) {
        return false;
      }

      $(`.${this.name}-filter`).on('click', (e) => {
        e.preventDefault();

        $(`.${this.name}-filter`).removeClass('selected');
        e.target.classList.add('selected');

        this.selectedFilters.push(e.target.dataset.value);
        $(`.${this.name}-title`).text(e.target.innerText).addClass('selected');
        this.applyFilter();
        $('.show').removeClass('show');
      });

      this.items = this.filterOptionsContainer.getElementsByClassName(`${this.name}-filter`);

      return false;
    }

    applyFilter() {
      const actualFilters = [];
      for (let i = 0, itemsCount = this.items.length; i < itemsCount; i += 1) {
        const filterLink = this.items[i];
        if (filterLink.classList.contains('selected')) {
          actualFilters.push(filterLink.dataset.value);
        }
      }

      const queryParams = UriHelper.parseQueryParams();
      const paramIndex = queryParams.findIndex(item => item.name === this.paramName);
      if (paramIndex !== -1) {
        queryParams[paramIndex].value = actualFilters.join(',');
      } else {
        queryParams.push({ name: this.paramName, value: actualFilters.join(',') });
      }
      const pageUrl = UriHelper.setQueryStr(queryParams);
      window.history.pushState({ path: `?${pageUrl}` }, '', `?${pageUrl}`);
      window.location.reload();

      /* eslint-disable no-use-before-define */
      setActiveResetFilters();
      /* eslint-enable no-use-before-define */
      $('#sort-dropdown-merchants').change();
    }
  }

  $(doc).ready(() => {
    const provideTypeFilter = new SearchFilter('delivery-type', { paramName: 'delivery_type' });
    const minimumOrderFilter = new SearchFilter('min-order-type', { paramName: 'min_order' });
    const minimumDeliveryFilter = new SearchFilter('min-delivery-type', { paramName: 'min_delivery' });
    provideTypeFilter.init();
    minimumOrderFilter.init();
    minimumDeliveryFilter.init();

    // if active filters present - show reset button
    /* eslint-disable no-use-before-define */
    setActiveResetFilters();
    /* eslint-enable no-use-before-define */

    $('.reset-filters').on('click', () => {
      /* eslint-disable no-use-before-define */
      resetFilters();
      setActiveResetFilters();
      /* eslint-enable no-use-before-define */

      return false;
    });
  });

  function resetFilters() {
    const queryParams = UriHelper.parseQueryParams();
    let changeUrl = false;

    $('.filters li.filter-opt').each(function initClearFilter() {
      const element = $(this).find('a.selected').first('a');
      if (element !== null) {
        element.text(element.data('origin'));
        $(this).find('a.selected').removeClass('selected');
        const type = element.data('type');
        if (type !== null) {
          const paramIndex = queryParams.findIndex(item => item.name === type);
          if (paramIndex !== -1) {
            queryParams.splice(paramIndex, 1);
            changeUrl = true;
          }
        }
      }
    });

    if (changeUrl === true) {
      const pageUrl = UriHelper.setQueryStr(queryParams);
      window.history.pushState({ path: `?${pageUrl}` }, '', `?${pageUrl}`);
      $('#sort-dropdown-merchants').change();
      window.location.reload();
    }

    return true;
  }


  function setActiveResetFilters() {
    const countSelected = $('.filters li.filter-opt').find('a.selected').length;
    if (countSelected > 0) {
      $('.reset-filters').show();
    } else {
      $('.reset-filters').hide();
    }
  }
})(window, window.jQuery);
